/**
 * DialogBody — shared wrapper for all dialog content.
 *
 * shadcn's DialogContent is a CSS grid, and grid items default to
 * `min-width: min-content`. That means wide children (long code lines,
 * unbroken tokens, tables) push the dialog past its `max-w-*` constraint.
 *
 * This wrapper forces the grid child to `min-width: 0`, which makes the
 * dialog respect its max-width and lets `overflow-x-hidden` + `truncate`
 * work as expected on descendants.
 *
 * Use this inside every DialogContent, wrapping the DialogHeader and body:
 *
 *   <DialogContent className="sm:max-w-xl ...">
 *     <DialogBody>
 *       <DialogHeader>...</DialogHeader>
 *       ...content...
 *     </DialogBody>
 *   </DialogContent>
 */
export function DialogBody({ children, className = "", spacing = "space-y-4" }) {
  return (
    <div className={`min-w-0 ${spacing} ${className}`}>
      {children}
    </div>
  );
}
